import React, { useState } from "react";
import { IconButton, ListItemIcon, MenuItem } from "@mui/material";
import TrailerMenu from "../TrailerMenu";
import FlagDE from "./FlagDE";
import FlagGB from "./FlagGB";
import { TLanguage, useLanguage } from "../../contexts/LanguageProvider";

const Flags = {
  de: FlagDE,
  en: FlagGB,
};

const LanguageSelect = () => {
  const [anchorElem, setAnchorElem] = useState<null | HTMLElement>(null);
  const [menu, setMenu] = useState<null | string>(null);
  const { language, switchLanguage } = useLanguage();

  const changeLanguage = (newLanguage: TLanguage) => {
    setMenu(null);
    switchLanguage(newLanguage);
  };

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    menu: string
  ) => {
    setMenu(menu);
    setAnchorElem(event.currentTarget);
  };

  const Flag = Flags[language];

  return (
    <div>
      <IconButton
        size="large"
        color="inherit"
        onClick={(e) => handleClick(e, "language")}
        data-cy="nav-user-icon"
      >
        <Flag width={24} />
      </IconButton>
      <TrailerMenu
        position="right"
        id="basic-menu"
        anchorEl={anchorElem}
        open={menu === "language"}
        onClose={(e) => setMenu(null)}
      >
        <MenuItem onClick={(e) => changeLanguage("de")}>
          <ListItemIcon>
            <FlagDE width={24} />
          </ListItemIcon>
          Deutsch
        </MenuItem>
        <MenuItem onClick={(e) => changeLanguage("en")}>
          <ListItemIcon>
            <FlagGB width={24} />
          </ListItemIcon>
          English
        </MenuItem>
      </TrailerMenu>
    </div>
  );
};

export default LanguageSelect;
